import CheckElement from '../../atoms/CheckElement/CheckElement';
import React, { Component } from 'react';
import './styles.css';
import Button from '../../atoms/Button';
import classNames from 'classnames';

/**
 * Description
 * @typedef {Object} Props
 * @prop {Object} plan
 */
export default class PricingCard extends Component {
	state = {
		isOpen: false,
	};

	/**
	 * @type {number}
	 */
	timeout;

	handleToggle = () => {
		this.setState(
			{
				isOpen: !this.state.isOpen,
			},
			() => {
				if (!this.featuresRef.current) return;

				window.clearTimeout(this.timeout); // Clear timeout in case user click faster than "animationDuration"
				const contentWrap = this.featuresRef.current;
				if (this.state.isOpen) {
					contentWrap.style.height = `${contentWrap.scrollHeight}px`;
					this.timeout = window.setTimeout(() => {
						contentWrap.style.height = 'auto';
					}, 3000);
				} else {
					contentWrap.style.height = `${contentWrap.scrollHeight}px`;
					this.timeout = window.setTimeout(() => {
						contentWrap.style.height = '230px';
					}, 0);
				}
			}
		);
	};

	handleButtonClick = () => {
		const { plan } = this.props;
		const { isOpen } = this.state;
		if (this.contactLink.current && plan.title === 'Enterprise' && isOpen) {
			this.contactLink.current.click();
		}
		this.handleToggle();
	};

	featuresRef = React.createRef();
	contactLink = React.createRef();

	genClassName = (state) =>
		classNames('pricingFeatures', {
			pricingFeaturesOpen: state.isOpen,
		});

	renderButtonText = () => {
		const { title } = this.props.plan;
		const { isOpen } = this.state;

		if (title === 'Enterprise') {
			return isOpen ? 'Contact us' : 'More';
		}

		return isOpen ? 'Less' : 'More';
	};

	render () {
		const { title, price, features, extraInfo } = this.props.plan;
		const { isOpen } = this.state;
		const arrowUp = isOpen && !(title === 'Enterprise');
		const showUpbtn = title === 'Enterprise' && isOpen;

		return (
			<div className='Card'>
				<h1>{title}</h1>
				<h2>
					{title === 'Enterprise' ? (
						<span className={'enterpriseCost'}>{price}</span>
					) : (
						<span>
							<span className={'priceSubtext'}>&#8364;</span>
							{price}
							<span className={'priceSubtext'}>/Month</span>
						</span>
					)}
				</h2>

				<div
					ref={this.featuresRef}
					className={this.genClassName(this.state)}
				>
					{features.map(({ checked, name }) => (
						<div className={'checkWrapper'} key={name}>
							<CheckElement checked={checked} />
							<h3>{name}</h3>
						</div>
					))}
				</div>
				<div className={'pricingGreenDivider'} />

				{extraInfo && <p className={'pricingExtraInfo'}>
					{extraInfo}
				</p>}

				{
					// eslint-disable-next-line
					<a
						href={'mailto:info@taggis.com?subject=Enterprise plan'}
						className={'pricingContactLink'}
						ref={this.contactLink}
					/>
				}

				<div className={'pricingButtonWrapper'}>
					{showUpbtn && (
						<Button
							arrowUp
							onClick={this.handleToggle}
							className={'upButton'}
						/>
					)}
					<Button
						arrowDown={!isOpen}
						arrowUp={arrowUp}
						onClick={this.handleButtonClick}
						className={'pricingCardButton'}
					>
						{this.renderButtonText()}
					</Button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/organisms/PricingCard/PricingCard.js